import { IPoint } from '../struck';
import { IImageTransform } from './image-layer';

/** 标注笔类型 */
export enum MarkupType {
    /** 箭头标注 */
    Arrow = 'arrow',
    /** 角度标注 */
    // Angle = 'angle',
    /** 2 段式标注 */
    Segment = 'segment',
    /** 图形标注 */
    // Shape = 'shape',
}

/** 标注笔端点形状 */
export enum MarkupLinecapType {
    /** 方形 */
    Square = 'square',
    /** 圆形 */
    Round = 'round',
}

/** 样式 */
export enum MarkupDasharrayType {
    /** 实线 */
    Solid = '',
    /** 方形虚线 */
    Square = '1,2',
    /** 圆点虚线 */
    Dot = '0,2',
    /** 间隔虚线 */
    Dashed = '2,2,1,2',
}

/** 端点类型 */
export enum MarkupPointType {
    /** 空类型 */
    None = '',
    /** 直线箭头 */
    StraightArrow = 'StraightArrow',
    /** 弧形箭头 */
    CurvedArrow = 'CurvedArrow',
    /** 尖头三角形 */
    SharpTriangle = 'SharpTriangle',
    /** 实心三角形 */
    SolidTriangle = 'SolidTriangle',
    /** 实心圆 */
    SolidCircle = 'SolidCircle',
    /** 镂空矩形 */
    HollowRect = 'HollowRect',
}

/** 标签文案单位 */
export enum MarkupLabelUnit {
    /** 毫米 */
    mm = 'mm',
    /** 厘米 */
    cm = 'cm',
    /** 英寸 */
    inch = 'inch',
    /** 米 */
    m = 'm',
}

/** 标签类型 */
export enum MarkupLabelType {
    /** 数值类型 */
    num = 'num',
    /** 自定义 */
    custom = 'text',
}

/** 标注笔端点 */
export interface IMarkupPoint {
    /** 素材地址 */
    url: string;
    /** 端点类型 */
    type: MarkupPointType;
    /** 4px,端点直线偏移量 */
    offset: number;
    /** 4px,图像宽 */
    width: number;
    /** 4px,图像高 */
    height: number;
}

/** 样式 */
export enum MarkupTextPositionType {
    /** 上 */
    Up = 'up',
    /** 中 */
    Center = 'center',
    /** 下 */
    Down = 'down',
    // /** 左 */
    // Left = 'left',
    // /** 右 */
    // Right = 'right',
}

export interface IMarkupAttribute {
    /** 颜色 */
    color: string;
    /** 样式 */
    dasharray: MarkupDasharrayType;
    /** 样式-形状 */
    linecap: MarkupLinecapType;
    /** 粗细 */
    width: number;
}
export interface IMarkupLabel {
    /** 位置 */
    position: MarkupTextPositionType;
    /** 旋转角度 */
    rotate: number;
    /** 宽 */
    width: number;
    /** 高 */
    height: number;
    /** 文案类型，如果为数值类型，需要根据units把num根据最小单位换算，展示全部单位，如：50cm/50mm */
    type: MarkupLabelType;
    /** 自定义内容 */
    text: string;
    /** 数值内容 */
    num: number;
    /** 数值单位 */
    units: MarkupLabelUnit[];
    /** 颜色 */
    color: string;
    /** 行间距 */
    lineSpacing: number;
    /** 字间距 */
    letterSpacing: number;
    /** 字号 */
    fontSize: number;
    /** 字体 */
    fontFamily: string;
    /** 加粗 */
    bold: boolean;
    /** 斜体 */
    italic: boolean;
    /** 中划线 */
    lineThrough: boolean;
    /** 下划线 */
    underline: boolean;
    /** 背景色 */
    background: string;
    /** 背景圆角 */
    roundWeight: number;
}

export interface IMarkupAnchor {
    /** 角度标注, 圆弧半径控制点, 相对标记边长度的百分比。 默认 0.4 */
    // arcRadius: number;
    /** 角度标注, 显示较小的夹角 */
    // arcLowAngle: boolean;

    /**
     * 绘制`角度标注`/`分段标注`的坐标点
     * 转折点为原点 (0,0)
     * 记录2个点的坐标
     **/
    points?: IPoint[];

    /** 箭头标注, 左边控制点, [1,-11] */
    arrowLeft: number[];
    /** 箭头标注, 右边边控制点 */
    arrowRight: number[];
}

/** 画笔配置 */
export interface IMarkupDrawConfig {
    /** 画笔类型 */
    markupType: MarkupType;
    /** 画笔素材地址 */
    // url: string;

    /** 文字标签 */
    label: IMarkupLabel;

    /** 锚点 */
    anchor: IMarkupAnchor;

    /**
     * 图形中心点相对图层左上点的偏移量
     * 中心点定义
     * 箭头标注：左边箭头起始点
     * 角度标注：转折点
     * 分段注：转折点
     */
    centerOffset: IPoint;

    /** 是否显示双边标记线  */
    hasLine: boolean;

    /** 填充样式 */
    fill: IMarkupAttribute;

    /** 线始端样式 */
    startPoint: IMarkupPoint;
    /** 线末端样式 */
    endPoint: IMarkupPoint;

    /** vip 标记，不写入配方 */
    __vipFuncType?: string;

    /** 绘制时候需要点击几次, 不写入配方 */
    __drawClick?: number;

    /** 是否是快捷键绘制 */
    __isQuickDraw?: boolean;
}

export interface IMarkupLayerProps extends IMarkupDrawConfig {
    /** 变换参数，翻转 */
    imageTransform: IImageTransform;

    /** 图形宽 */
    // naturalWidth: number;
    /** 图形高 */
    // naturalHeight: number;

    /** 结果图 */
    screenshotUrl?: string | null;
}
